module.exports = __webpack_public_path__ + "96a024e5360dd535e0c4f4e660f3aeb4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-left-23.png
// module id = 2567
// module chunks = 0